export const mainMenuList = [
  {
    title: 'トップページ',
    path: '/',
    outer: false,
    prefetch: false,
  },{
    title: 'マイページ',
    path: '/mypage',
    outer: false,
    prefetch: false,
  },{
    title: '商品一覧',
    path: '/items',
    outer: false,
    prefetch: true,
  },{
    title: '栄養士おまかせ定期便',
    path: '/teiki/',
    outer: false,
    prefetch: true,
  },{
    title: 'カタログ',
    path: '/catalog/view',
    outer: false,
    prefetch: true,
  }
]

export const subMenuList = [
  {
    title: 'スイーツコレクション',
    path: '/sweets-collection',
    outer: false,
    prefetch: false,
  },{
    title: 'カタログ配布施設一覧',
    path: '/catalog',
    outer: false,
    prefetch: false,
  },{
    title: 'ミールタイムが選ばれる理由',
    path: '/reason',
    outer: false,
    prefetch: false,
  },{
    title: 'ミールタイム品質',
    path: '/quality',
    outer: false,
    prefetch: false,
  },{
    title: 'ミールタイムのここがいい',
    path: '/partners',
    outer: false,
    prefetch: false,
  },{
    title: '数値改善ハッピーレポート',
    path: '/happy_reports',
    outer: false,
    prefetch: false,
  },{
    title: 'ミールタイム栄養士一覧',
    path: '/dietitians',
    outer: false,
    prefetch: false,
  },{
    title: 'メディカルネットブック',
    path: 'https://m-netbook.mealtime.jp/?mt',
    outer: true,
    prefetch: false,
  },
]

export const otherMenuList = [
  {
    title: 'お知らせ',
    path: '/topics',
    outer: false,
    prefetch: false,
  },{
    title: 'ご利用ガイド / よくある質問',
    path: '/guide',
    outer: false,
    prefetch: false,
  },{
    title: 'ログアウト',
    path: '/logout',
    outer: false,
    prefetch: false,
  }
]

export const shopList = [
  {
    title: '会計へ進む',
    path: '/cart',
    outer: false,
    prefetch: false,
  },{
    title: '商品一覧へ',
    path: '/items',
    outer: false,
    prefetch: false,
  },{
    title: 'お気に入り',
    path: '/',
    outer: false,
    prefetch: false,
  }
  // ,{
  //   title: 'マイページ',
  //   path: '/mypage/',
  //   outer: false,
  //   prefetch: false,
  // }
]

